import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout-only route — index page lives in `seo-for.index.tsx` to avoid
// emitting a duplicate canonical/hrefLang link tag on child industry pages.
export const Route = createFileRoute("/seo-for")({
  component: () => <Outlet />,
});
